/**
 * Status of risk limit report.
 * tag: 2316
 * @readonly
 * @enum {number} (int)
 */
export enum RiskLimitReportStatus {
  /** Accepted */
  Accepted = 0,
  /** Rejected */
  Rejected = 1,
}
